module.exports = __webpack_public_path__ + "static/media/tick-circle.2e00c4ab.png";